/** @jsxImportSource @emotion/react */

import { MedicalImage } from "../../../../assets/img/img";
import useBasePadding from "../../../../hooks/useBasePadding";
import useResponsive from "../../../../hooks/useResponsive";

const texts = {
  title: `인공지능을 통한
캡슐 내시경 판독 시간 단축
의료진을 보조하여 조기 진단에
기여합니다.`,
  contentPc: `캡슐 내시경은 소장을 검진하기 위한 주요 내시경 검사 방법 중 하나입니다.
다만, 전체 영상을 판독하기 위해서는 10시간 이상 녹화된 장시간의 영상 프레임을
의료진이 직접 연속하여 검터해야 하는 번거로움이 있습니다.
(주)서르의 CAPTOS는 인공지능(CNN) 기술을 활용해 캡슐 내시경 영상 내 패턴·색조·구조적 특징을 분석하고, 
이상부위 후보의 위치 및 개수 정보를 BBOX(박스) 및 BAR 형태로 시각화 하여 제공합니다.
  
본 제품은 영상 판독 시 의료진의 탐색 효율을 높이고 시각적 검토를 보조하는 독립형 분석보조 소프트웨어입니다.
(※ 본 제품은 캡슐 내시경 영상 내 이상 패턴 정보를 생성·표시하는 분석보조 도구이며, 의학적 진단, 질병 여부 확정, 
병변 판단 및 중증도 결정 목적으로는 사용되지 않습니다.)`,
  contentMobile: `캡슐 내시경은 소장을 검진하기 위한 
주요 내시경 검사 방법 중 하나입니다.
다만, 전체 영상을 판독하기 위해서는 
10시간 이상 녹화된 장시간의 영상 프레임을 
의료진이 직접 연속하여 검토해야 하는 번거로움이 있습니다.
(주)서르의 CAPTOS는 인공지능(CNN) 기술을 활용해
캡슐 내시경 영상 내 패턴·색조·구조적 특징을 분석하고, 
이상부위 후보의 위치 및 개수 정보를 BBOX(박스) 및 
BAR 형태로 시각화 하여 제공합니다.
  
본 제품은 영상 판독 시 의료진의 탐색 효율을 높이고
시각적 검토를 보조하는 독립형 분석보조 소프트웨어입니다.
(※ 본 제품은 캡슐 내시경 영상 내 이상 패턴 정보를 생성·표시하는 
분석보조 도구이며, 의학적 진단, 질병 여부 확정, 병변 판단 및
중증도 결정 목적으로는 사용되지 않습니다.)`,
};

export default function Section1() {
  const { GOLBAL_PADDING } = useBasePadding();
  const { isMobile, isTablet, isPc } = useResponsive();
  return (
    <div css={wrapper(GOLBAL_PADDING, !isPc)}>
      {!isPc ? (
        <div css={isPcStyle(isPc)}>
          <pre css={title(!isPc)}>{texts.title}</pre>
          <div
            css={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "30px",
            }}
          >
            <img
              css={
                !isMobile
                  ? {
                      width: "270px",
                      height: "250px",
                      marginLeft: "12px",
                    }
                  : {
                      width: "180px",
                      height: "auto",
                      marginLeft: "12px",
                    }
              }
              src={MedicalImage.Img1}
              alt="section1"
            />
            <pre css={description(!isPc)}>{texts.contentMobile}</pre>
          </div>
        </div>
      ) : (
        <div css={isTablet ? { maxWidth: "460px" } : textBox}>
          <p css={title(!isPc)}>
            인공지능을 통한 캡슐 내시경 판독 시간 단축
            <br /> 의료진을 보조하여 조기 진단에 기여합니다.
          </p>
          <pre css={description(!isPc)}>{texts.contentPc}</pre>
        </div>
      )}
      {isPc && (
        <div>
          <img css={{ width: "416px", height: "450px", marginLeft: "64px" }} src={MedicalImage.Img1} alt="section1" />
        </div>
      )}
    </div>
  );
}

const wrapper = (padding: string, isMobile: boolean) => ({
  display: "flex",
  flexDirection: isMobile ? ("column" as const) : ("row" as const),
  justifyContent: "center",
  alignItems: "center",
  paddingLeft: padding,
  paddingRight: padding,
  background: "black",
  marginTop: isMobile ? "100px" : "200px",
  padding: "75px",
});

const textBox = {
  maxWidth: "760px",
};

const title = (isMobile: boolean) => ({
  color: "white",
  fontSize: isMobile ? "24px" : "32px",
  fontWeight: "600",
  lineHeight: "38px",
  textAlign: isMobile ? ("center" as const) : undefined,
});

const description = (isMobile: boolean) => ({
  marginTop: "30px",
  color: "white",
  fontSize: isMobile ? "14px" : "18px",
  fontWeight: "400",
  lineHeight: isMobile ? "20px" : "27px",
  textAlign: isMobile ? ("center" as const) : undefined,
});

const isPcStyle = (isPc: boolean) => ({
  display: isPc ? "" : "flex",
  flexDirection: isPc ? undefined : ("column" as const),
  gap: isPc ? "" : "30px",
});
